module.exports = __webpack_public_path__ + "Server-Default.None.67e987025120de5c508c9a980e53879c.hashedasset.svg";